module.exports = "/_next/static/images/chris-8b865d5cf392863967ddd62fdc7c2012.jpg";